import * as React from 'react';

import {Button} from '../button/button';

import styles from './status-bar.module.css';

export type Props = {
    text: string;
    linkProps?: {
        onClick: () => void;
        linkText: string;
    };
};

export function StatusBarPrimaryText(props: Props) {
    return (
        <div className='flex'>
            <div className={styles['primary-text-container']}>
                {props.text}
                {props.linkProps ? (
                    <Button
                        size='big'
                        variant='text-primary'
                        onClick={props.linkProps.onClick}
                        noPadding={true}
                    >
                        {props.linkProps.linkText}
                    </Button>
                ) : undefined}
            </div>
        </div>
    );
}
